import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();

  // Excluir el footer si el componente hijo ya lo maneja (opcional)
  const hideFooterOn = ['/projects/:id']; // puedes ajustar esto si decides manejarlo desde dentro

  return (
    <div className="flex flex-col min-h-screen bg-[#2A2A2A] text-[#D9D9D9] transition-colors duration-300">
      <Navbar />
      <main className="flex-grow relative z-0">
        {children}
      </main>
      {/* El footer siempre aparece al final excepto si se fuerza su exclusión */}
      <Footer />
    </div>
  );
};

export default MainLayout;
